/* unplugin-vue-components disabled */import { render } from "./reword.vue?vue&type=template&id=ec5277e0&scoped=true"
import script from "./reword.vue?vue&type=script&lang=js"
export * from "./reword.vue?vue&type=script&lang=js"

import "./reword.vue?vue&type=style&index=0&id=ec5277e0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5277e0"]])

export default __exports__